export const  GET_GRADES_REQUEST='getGradesReducer/GET_GRADES_REQUEST';
export const  GET_GRADES_SUCCESS='getGradesReducer/GET_GRADES_SUCCESS';
export const  GET_GRADES_FAILED='getGradesReducer/GET_GRADES_FAILED';